<div>
  <div class="alignDeviceType">
    <label [attr.name]="'lbl' + name" class="control-label">{{ label }}
    </label>
    <select [name]="name" class="form-control" (change)="onContentTypeChange($event)"
      [(ngModel)]="contentTypeId">
      <option value="1" selected>Unique</option>              
      <option value="2">Mirror</option>              
    </select>
  </div>  
</div>
